<!--
 * @Author: Lemon C
 * @Date: 2024-04-28 18:22:58
 * @LastEditTime: 2024-12-16 11:42:52
-->
<template>
    <div
        class="sup-docs-breadcrumb"
        :style="`${state_store.need_docsBreadcrumb_shadow ? 'box-shadow: 0px 10px 10px -10px rgba(206, 223, 255, 0.8);' : ''}`">
        <el-breadcrumb class="docs-breadcrumb-box" separator-icon="ArrowRight">
            <el-breadcrumb-item v-for="(item, index) in breadcrumb_list" :key="index" :title="item.name">
                {{ item.name }}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, getCurrentInstance } from 'vue';
import { useStateStore } from '@/stores/state';

const state_store = useStateStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    switch_type: Number,
});

const breadcrumb_list = ref([]);

// MARK Update  更新数据
const update_data = (tree_sel_node_id, treeList) => {
    let breadcrumb_temp = treeList.map((node) => find_tree_node_path(node, tree_sel_node_id)).find((p) => p); // 查询节点面包屑
    if (props.switch_type) {
        let rootTypeData = proxy.$globalObj.docs_switch_list.find((obj) => obj.id === props.switch_type);
        breadcrumb_temp.unshift({ name: rootTypeData.name });
    }
    breadcrumb_list.value = breadcrumb_temp;
};
// MARK Tree  多级数组嵌套查询路径
const find_tree_node_path = (node, findKey, path = []) => {
    // 将当前节点的名称添加到路径数组中
    const currentPath = [...path, node];
    // 检查当前节点的名称是否是目标名称
    if (node.id === findKey) {
        return currentPath;
    }
    // 如果当前节点有子节点，继续遍历它们
    for (const child of node.subCatalogs) {
        const resultPath = find_tree_node_path(child, findKey, currentPath);
        // 如果找到目标节点的路径，返回结果
        if (resultPath) {
            return resultPath;
        }
    }
    // 如果在这个节点的子树中没有找到目标，返回 null
    return null;
};

// 将 update_data 方法暴露给父组件
defineExpose({
    update_data,
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-breadcrumb {
    padding: 0 40px;
    padding-top: 18px;
    box-sizing: border-box;

    :deep(.el-breadcrumb) {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        .el-breadcrumb__item {
            user-select: none;
            display: flex;
            align-items: center;

            .el-breadcrumb__inner {
                display: flex;
                height: 100%;
                color: var(--color-main-text-secondary);
                font-size: 18px;
                font-weight: 500;
                line-height: 27px;
            }

            &:last-child .el-breadcrumb__inner {
                color: var(--color-main-text-primary);
                font-weight: bold;
            }
        }
    }
}
</style>
